module.exports = __webpack_public_path__ + "media/images/logo_BACREA-1c4c8888037a75535994c64ab7d06667.png";